<template>
    <div class="h-full flex flex-col bg-white">
        <div class="sticky top-0 z-50 bg-white w-full h-[64px] border-b border-gray-DFDFDF px-[20px] lg:px-[40px] flex items-center justify-center">
            <h2 class="font-semibold leading-none font-oceanside">
                {{ $t('PREVIEW') }}
            </h2>
            <button
                type="button"
                class="absolute right-[20px] lg:right-[40px] focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2"
                :aria-label="$t('COLOR_CHANGE_CONFIRM_CLOSE')"
                @click="closePanel"
            >
                <img src="../assets/images/icons/close.svg" class="w-[18.84px] h-auto" alt="" />
            </button>
        </div>

        <product-renderer-wrapper
            :show-toolbar="showToolbar"
            :show-zoom="false"
            class="min-h-0 flex-1"
        >
        </product-renderer-wrapper>
        <div class="border-t border-gray-DFDFDF px-[20px] lg:px-[40px] py-[16px] bg-white h-[90px] flex items-center justify-center">
            <button
                type="button"
                :class="[
                    'h-[40px] min-h-[40px] rounded-full border border-red bg-red text-white leading-none font-oceanside w-full',
                    'font-semibold',
                    'focus:outline-none focus:ring-1 focus:ring-black focus:border-black',
                ]"
                @click="closePanel"
            >
                {{ $t('BACK_TO_DESIGN') }}
            </button>
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import ProductRendererWrapper from './ProductRendererWrapper.vue';

    export default {
        name: 'PreviewPanel',

        mixins: [allStores],

        components: {
            ProductRendererWrapper,
        },

        props: {
            showToolbar: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            closePanel() {
                this.appStore.closeNestedPanel();
            },
        },
    };
</script>
